import React from 'react';
import { LinkedinIcon, TwitterIcon, MailIcon } from 'lucide-react';
export function Footer() {
  const footerLinks = {
    company: [{
      name: 'How It Works',
      href: '/how-it-works'
    }, {
      name: 'Who We Serve',
      href: '/who-we-serve'
    }, {
      name: 'Case Studies',
      href: '/case-studies'
    }, {
      name: 'About',
      href: '/about'
    }],
    legal: [{
      name: 'Privacy Policy',
      href: '/privacy'
    }]
  };
  return <footer className="bg-navy text-white" data-id="element-26">
      <div className="container-custom py-12 md:py-16" data-id="element-27">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-id="element-28">
          {/* Brand */}
          <div data-id="element-29">
            <div className="text-2xl font-black mb-4 text-white" data-id="element-30">HIRE</div>
            <p className="text-gray-300 text-sm leading-relaxed mb-4" data-id="element-31">
              The recruiting, retention, and rookie success engine for
              high-growth D2D and direct sales companies.
            </p>
            <div className="flex space-x-4" data-id="element-32">
              <a href="#" className="text-gray-300 hover:text-amber transition-colors" data-id="element-33">
                <LinkedinIcon className="h-5 w-5" data-id="element-34" />
              </a>
              <a href="#" className="text-gray-300 hover:text-amber transition-colors" data-id="element-35">
                <TwitterIcon className="h-5 w-5" data-id="element-36" />
              </a>
              <a href="mailto:contact@thehireadvantage.co" className="text-gray-300 hover:text-amber transition-colors" data-id="element-37">
                <MailIcon className="h-5 w-5" data-id="element-38" />
              </a>
            </div>
          </div>

          {/* Company */}
          <div data-id="element-39">
            <h4 className="font-bold mb-4" data-id="element-40">Company</h4>
            <ul className="space-y-2" data-id="element-41">
              {footerLinks.company.map(link => <li key={link.name} data-id="element-42">
                  <a href={link.href} className="text-gray-300 hover:text-amber transition-colors text-sm" data-id="element-43">
                    {link.name}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-44">
            <h4 className="font-bold mb-4" data-id="element-45">Get Started</h4>
            <p className="text-gray-300 text-sm mb-4" data-id="element-46">
              Ready to install your recruiting engine?
            </p>
            <a href="/book-call" className="inline-block bg-amber hover:bg-amber-dark text-navy font-semibold px-6 py-2 rounded transition-colors" data-id="element-47">
              Book a Call
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0" data-id="element-48">
          <p className="text-gray-400 text-sm" data-id="element-49">
            © {new Date().getFullYear()} The HIRE Advantage. All rights
            reserved.
          </p>
          <div className="flex space-x-6" data-id="element-50">
            {footerLinks.legal.map(link => <a key={link.name} href={link.href} className="text-gray-400 hover:text-amber transition-colors text-sm" data-id="element-51">
                {link.name}
              </a>)}
          </div>
        </div>
      </div>
    </footer>;
}